<div class="row">
  <div class="col-md-12">
    <div class="card AddInsurance_popup">
      <div class="row">
        <div class="col-md-12 mb-lg-0 mb-3">
          <h3 class="font-weight-bold title_size20">Add Insurance</h3>
          <div class="card-body p-0">
            <form [formGroup]="insuranceForm" (ngSubmit)="submitForm()">
              <!-- Card Holder -->
              <div class="form-group">
                <label for="card_holder">Card Holder</label>
                <input
                  type="text"
                  class="form-control"
                  id="card_holder"
                  placeholder="Enter card holder name"
                  formControlName="card_holder"
                />
                <!-- <mat-error
                  *ngIf="
                    insuranceForm.get('card_holder').invalid &&
                    (insuranceForm.get('card_holder').dirty ||
                      insuranceForm.get('card_holder').touched)
                  "
                >
                  Card holder name is required
                </mat-error>` -->
              </div>
              <!-- Insurance Provider -->
              <div class="form-group">
                <label for="insurance_provider">Insurance Provider</label>
                <input
                  type="text"
                  class="form-control"
                  id="insurance_provider"
                  placeholder="Enter insurance provider name"
                  formControlName="insurance_provider"
                />
                <!-- <mat-error
                  *ngIf="
                    insuranceForm.get('insurance_provider').invalid &&
                    (insuranceForm.get('insurance_provider').dirty ||
                      insuranceForm.get('insurance_provider').touched)
                  "
                >
                  Insurance provider name is required
                </mat-error> -->
              </div>
              <!-- Carrier Number -->
              <div class="form-group">
                <label for="carrier_number">Carrier Number</label>
                <input
                  type="number"
                  class="form-control"
                  id="carrier_number"
                  placeholder="Enter carrier number"
                  formControlName="career_number"
                />
                <!-- <mat-error
                  *ngIf="
                    insuranceForm.get('career_number').invalid &&
                    (insuranceForm.get('career_number').dirty ||
                      insuranceForm.get('career_number').touched)
                  "
                >
                  Carrier number is required
                </mat-error> -->
              </div>
              <!-- Contract Plan Number -->
              <div class="form-group">
                <label for="contract_plan_number">Contract Plan Number</label>
                <input
                  type="number"
                  class="form-control"
                  id="contract_plan_number"
                  placeholder="Enter contract plan number"
                  formControlName="contract_plan_number"
                />
                <!-- <mat-error
                  *ngIf="
                    insuranceForm.get('contract_plan_number').invalid &&
                    (insuranceForm.get('contract_plan_number').dirty ||
                      insuranceForm.get('contract_plan_number').touched)
                  "
                >
                  Contract plan number is required
                </mat-error> -->
              </div>

              <div class="form-group">
                <label for="contract_plan_number">Member ID/Certificate number</label>
                <input
                  type="number"
                  class="form-control"
                  placeholder="Enter Member ID/Certificate number"
                  formControlName="memberId"
                />
                <!-- <mat-error
                  *ngIf="
                    insuranceForm.get('memberId').invalid &&
                    (insuranceForm.get('memberId').dirty ||
                      insuranceForm.get('memberId').touched)
                  "
                >
                Member ID/Certificate number is required
                </mat-error> -->
              </div>

              <!-- Front and Back -->
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="front">Front</label>
                    <!-- <input type="file" id="fileInput" (change)="onFrontFileChange($event)" class="form-control pl-1" style="line-height: 28px;"/> -->
                    <input type="file" id="fileInput" (change)="onFrontFileChange($event)" class="form-control pl-1" style="line-height: 28px;" accept="image/*"/>

                    <!-- <mat-error
                      *ngIf="
                        insuranceForm.get('front').invalid &&
                        (insuranceForm.get('front').dirty ||
                          insuranceForm.get('front').touched)
                      "
                    >
                      Front is required
                    </mat-error> -->
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="back">Back</label>
                    <!-- <input type="file" id="fileInput" (change)="onBackFileChange($event)"  class="form-control pl-1" style="line-height: 28px;"/> -->
                    <input type="file" id="fileInput" (change)="onBackFileChange($event)"  class="form-control pl-1" style="line-height: 28px;" accept="image/*"/>

                    <!-- <mat-error
                      *ngIf="
                        insuranceForm.get('back').invalid &&
                        (insuranceForm.get('back').dirty ||
                          insuranceForm.get('back').touched)
                      "
                    >
                      Back is required
                    </mat-error> -->
                  </div>
                </div>
              </div>


              <!-- <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="front">Front</label>
                    <input
                      type="file"
                      class="form-control"
                      id="front"
                      formControlName="front"
                      (change)="handleFrontImage($event)"
                    />

                    <mat-error
                      *ngIf="
                        insuranceForm.get('front').invalid &&
                        (insuranceForm.get('front').dirty ||
                          insuranceForm.get('front').touched)
                      "
                    >
                      Front is required
                    </mat-error>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="back">Back</label>
                    <input
                      type="file"
                      class="form-control"
                      id="back"
                      formControlName="back"
                      (change)="handleBackImage($event)"
                    />

                    <mat-error
                      *ngIf="
                        insuranceForm.get('back').invalid &&
                        (insuranceForm.get('back').dirty ||
                          insuranceForm.get('back').touched)
                      "
                    >
                      Back is required
                    </mat-error>
                  </div>
                </div>
              </div> -->

              <div class="row">
                <div class="col-12 d-flex justify-content-end">
            
                  <button
                    class="custom-btn mt-3"
                    type="button"
                    (click)="this.dialogRef.close()"
                  >
                    Cancel
                  </button>
                  <button class="custom-btn mt-3 ml-2" type="submit">
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
